module.exports = __webpack_public_path__ + "static/media/nps-survey.e137657e.jpg";